/**
 * Label Service Headless Pool
 * Using the unified headless pool system from @things-factory/shell
 */

import { getOrCreateHeadlessPool, HEADLESS_POOL_ARGUMENT_SETS } from '@things-factory/shell'
import { pubsub } from '@things-factory/shell'
import { fonts } from './fonts.js'

// Custom setup function for label page
async function setupLabelPage(browser: any) {
  const protocol = 'http'
  const host = 'localhost'
  const path = '/internal-label-command-view'
  const port = process.env.PORT
  const url = `${protocol}://${host}:${port}${path}`

  const page = await browser.newPage()
  const [fontsToUse, fontStyles] = await fonts()

  await page.setRequestInterception(true)

  page.on('console', async msg => {
    console.log(`[headless ${msg.type()}] ${msg.text()}`)
  })

  page.on('pageerror', error => {
    console.log(`[headless pageerror] ${error.message}`)
    console.log(error.stack)
  })

  page.on('error', error => {
    console.log(`[headless fault] ${error}`)
    console.log(error.stack)
  })

  page.on('requestfailed', request => {
    console.log('Request failed:', request.url())
  })

  page.on('request', request => {
    if (request.url() === url) {
      request.continue({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        postData: JSON.stringify({
          fonts: fontsToUse,
          fontStyles
        })
      })
    } else {
      request.continue()
    }
  })

  await page.goto(url, { timeout: 0, waitUntil: 'load' })

  return { browser, page }
}

// Create the label pool instance with custom setup
const labelPool = getOrCreateHeadlessPool('label', {
  min: 2,
  max: 10,
  args: [
    ...HEADLESS_POOL_ARGUMENT_SETS.basic,
    ...HEADLESS_POOL_ARGUMENT_SETS.keychain_safe
  ],
  acquireTimeoutMillis: 15000,
  testOnBorrow: true,
  enableCleanup: true,
  customSetup: setupLabelPage
})

// Font change event subscription
setTimeout(async () => {
  const eventSource = pubsub.subscribe('notify-font-changed')
  for await (const data of eventSource) {
    // Reset the pool when fonts change
    await labelPool.reset()
  }
})

/**
 * Get the label headless pool
 * @returns Pool instance with acquire/release methods
 */
export function getHeadlessPool() {
  return {
    acquire: () => labelPool.acquire(),
    release: (resource: any) => labelPool.release(resource),
    size: 0, // These will be dynamically calculated if needed
    available: 0,
    borrowed: 0,
    pending: 0,
    max: 10,
    min: 2,
    clear: () => labelPool.reset() // For font change compatibility
  }
}